import clsx from 'clsx';
import { observer } from 'mobx-react';
import { currentUserStore } from '../../../../../../../CurrentUserStore';
import { findLink } from '../../../../../../../LinkyLinky';
import { T } from '../../../../../../../Translations';
import CoachingPortalIcon from '../../../../../../Cutesies/CoachingPortalIcon';

const CoachingPortalLink: React.FC = () =>
  findLink('coaching-portal-app', currentUserStore.links)
    .map((link) => (
      <li className={'flex no-underline relative font-semibold cursor-pointer'}>
        <a
          href={link.href}
          rel="noopener noreferrer"
          data-intercom-target="coaching-portal-navigation"
          className={clsx(
            'justify-items-start px-3',
            'flex justify-around',
            'items-center text-xs leading-6 text-foreground hover:text-primary',
          )}
        >
          <span className="h-10 m-2">
            <CoachingPortalIcon />
          </span>
          <span className="pl-3 text-lg">
            <T kind="Coaching" />
          </span>
        </a>
      </li>
    ))
    .getOrElse(() => <></>);

export default observer(CoachingPortalLink);
